import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {FormBuilder} from "@angular/forms";
import {Allegato, IntegrazioneIstanzaAllDTO} from "../../models/integrazione";
import {TributiService} from "../../services/tributi.service";
import {ActivatedRoute, Router} from "@angular/router";
import {AlertService} from "../../shared/alert/alert.service";
import {SubscriptionManager} from "../../shared/subscription-manager/subscription-manager.class";
import {zonedTimeToUtc} from "date-fns-tz";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";

export enum FileSupportati{
  PDF = 'application/pdf',
  PNG = 'image/png',
  ZIP = 'application/x-zip-compressed',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  JPEG = 'image/jpeg'
}

@Component({
  selector: 'jhi-integrazione',
  templateUrl: './integrazione.component.html',
  styleUrls: ['./integrazione.component.scss']
})

export class IntegrazioneComponent extends SubscriptionManager implements OnInit {
  listaIstanzeAllegato: Array<Allegato>;
  listaAllegati: Array<Allegato>;
  integrazioneResponse!: IntegrazioneIstanzaAllDTO;
  idIstanza: string;
  loading: boolean;
  loadingFile: boolean;
  maxSize: number;
  width: number;
  curIndex: number;
  @ViewChild('_MD_ALLEGATO') _md_allegato!: ElementRef;
  selectedLanguage: string = this.translateService.currentLang;

  constructor(private tributiService: TributiService, private translateService: TranslateService, private _fb: FormBuilder, private activatedRoute: ActivatedRoute, private router: Router, private alertService: AlertService) {
    super();
    this.loading = false;
    this.loadingFile = false;
    this.idIstanza = this.activatedRoute.snapshot.paramMap.get('idIntegrazione') ?? '';
    this.listaIstanzeAllegato = [];
    this.listaAllegati = [];
    this.maxSize = 52428800;
    this.width = window.innerWidth;
    this.curIndex = 0;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: UIEvent): void {
    this.width = (event.target as Window).innerWidth;
  }

  ngOnInit(): void {
    this.getIntegrazione(this.idIstanza);
    this.subs.sink = this.translateService.onLangChange.subscribe((langChangeEvent: LangChangeEvent) => {
      this.selectedLanguage = langChangeEvent.lang
    });
  }

  integraIstanza(): void {
    this.loading = true;
    this.listaIstanzeAllegato.forEach(istAll => {
      if(!istAll.contenuto){
        istAll.contenuto = '';
      }
      this.listaAllegati.push(istAll);
    })
    this.subs.sink = this.tributiService.integraIstanza(this.integrazioneResponse.integrazione.id, this.listaAllegati).subscribe({
      error: (err) => {
        this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 5000, true);
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
        this.router.navigate(['Servizi/IstanzeEmesse'], {state: {messaggio: "Integrazione avvenuta con successo"}});
      }
    });
  }

  rimuoviContenuto(index: number): void{
    this.listaIstanzeAllegato[index].contenuto = '';
    this.listaIstanzeAllegato[index].titolo = '-';
  }

  inserisciFileAllegato(event: any, index: number): void{
    const file = event.target.files[0];
    this.aggiornaContenuto(file, index);
  }

  dropFileAllegato(event: any, index: number): void{
    const file = event[0];
    if(Object.values(FileSupportati).includes(file.type)){
      this.aggiornaContenuto(file, index);
    }else{
      this.alertService.creaAlert("Inserire un file di tipo pdf, zip, png, jpeg o dockx", "danger", "sticky", 5000, true)
    }
  }

  aggiornaContenuto(file: File, index: number): void{
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if(reader.result){
          this.listaIstanzeAllegato[index].contenuto = reader.result.toString().split(',')[1];
          this.listaIstanzeAllegato[index].titolo = file.name;
          this.listaIstanzeAllegato[index].size = file.size;
        if(this.width > 1000){
          this._md_allegato.nativeElement.click();
        }
      }
    };
  }

  goBack(): void {
    if (window.history.state.previousRoute) {
      void this.router.navigate([window.history.state.previousRoute])
    } else {
      void this.router.navigate(['Servizi/IstanzeEmesse']);
    }
  }

  getIntegrazione(idIstanza?: null | string): void {
    this.loading = true;
    this.subs.sink = this.tributiService.getIntegrazione(<string>idIstanza).subscribe({
      next: (res: IntegrazioneIstanzaAllDTO) => {
        this.integrazioneResponse = res;
        this.listaIstanzeAllegato = res.allegati;
      },
      error: (error) => this.loading = false,
      complete: () => {
          this.loading = false;
      }
    })
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes: number | undefined, decimals: number): string {
    if (bytes && bytes === 0) {
      return '0 Bytes';
    }else if(bytes){
      const k = 1024;
      const dm = decimals <= 0 ? 0 : decimals || 2;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)).toString() + ' ' + sizes[i];
    }else {
      return '';
    }
  }

  formatDate(date: Date): Date{
    return zonedTimeToUtc(date, 'Europe/Rome');
  }
}
